// This file contains details about the meter properties that this project will have. It was
// originally created to fix a circular dependency that existed between
// site-consts -> logger -> site-consts by removing all imports from site-consts.
import appLogger from './logger';

const mlogger = appLogger.getLogger('site-consts');
// mlogger.logLevel = mlogger.loggerLevels.debug;

// const API_BASE = 'https://vinton-meter-swap.carlsapp.com/api';
// const STORAGE_KEY = 'MeterData';
// const WINDOW_TITLE = 'Vinton Meter Swap';
// const APP_VERSION = '2.8';
const ROUTE_KEY = 'Route Name';
const NUM_DETAILS_SHOW = 3;
const METER_ID_RE = /^2200[0-9]{5}$/;
const TRANSMITTER_ID_RE = /^130[0-9]{6}$/;
// const METER_ID_RE = /^[0-9]{9}$/;
// const TRANSMITTER_ID_RE = /^[0-9]{9}$/;

const PROP_TYPES = {
    BOOL: Boolean,
    STRING: String,
    NUMBER: Number,
    SELECT: 'Select',
    SELECT_MULTI: 'Select Multiple',
    SELECT_EDITABLE: 'Select Editable',
    SELECT_MULTI_EDITABLE: 'Select Multiple Editable',
    BARCODE: 'Barcode',
    TEXTAREA: 'Text Area',
    DATE: 'Date',
    ISO_TIMESTAMP: 'ISO Timestamp',
    INSTALL_TYPE: 'Install Type',
    TIMER_TEXT: 'Timer Text',
    CREW_WITH_HOURS: 'Crew With Hours',
};

// const DEFAULT_IMPORT_FILE_FORMAT = 'Fixed Width';
const FEATURE_TOGGLES = {
    GPS_EDITABLE: true,
};

// The meter props is a list of all the properties we have for the meters
//   key - The meter property name that contains the value for this property meter[prop.key]
//   type - The type of the prop. Possible values: Boolean, String, Number
//   TODO Complete this list
const METER_PROPS = [
    { key: 'Meter ID', type: PROP_TYPES.NUMBER },
    { key: 'Account ID' },
    { key: 'Location ID', type: PROP_TYPES.NUMBER },
    { key: 'Service Point ID', type: PROP_TYPES.NUMBER },
    { key: 'Service Point Route', type: PROP_TYPES.NUMBER },
    { key: 'Route Name' },
    { key: 'Service Point Latitude', type: PROP_TYPES.NUMBER },
    { key: 'Service Point Longitude', type: PROP_TYPES.NUMBER },
    { key: 'Customer Name' },
    { key: 'Billing Address', align: 'left' },
    { key: 'Service Address', align: 'left' },
    { key: 'Outgoing Meter Serial' },
    { key: 'Outgoing Endpoint Serial' },
    { key: 'Last Read Time' },
    { key: 'Last Read Value', type: PROP_TYPES.NUMBER },
    { key: 'Last Read Unit' },
    { key: 'Last Read Method' },
    { key: 'Register Resolution', type: PROP_TYPES.NUMBER },
    { key: 'Endpoint Type' },
    { key: 'Connection Type' },
    { key: 'Endpoint Status' },
    {
        key: 'Crew Members',
        modifiable: true,
        type: PROP_TYPES.CREW_WITH_HOURS,
        rememberLast: true,
        crew: [
            'Greg Austin', 'Sherman Austin', 'CJ Boothe', 'Taylor Campbell', 'Brian Cook',
            'Devin Fowler', 'Hunter McCoy', 'Casey Perkins',
        ],
        onSave: function onCrewMembersSave(meter, lastUsedSettings) {
            const flogger = mlogger.getLogger('crew-members-onsave');
            flogger.logLevel = flogger.loggerLevels.debugall;
            // We only want output from this function when we're debugging issues, so we'll
            // log at a debug or debugall level in this function.
            flogger.debug(`Saving crew members (${JSON.stringify(meter['Crew Members'])}) for our default value`);
            if (!Array.isArray(meter['Crew Members'])) {
                lastUsedSettings.lastCrewSelected = undefined;
                return;
            }
            const lastCrew = [];
            for (let i = 0; i < meter['Crew Members'].length; i++) {
                flogger.debugall(`Massaging crew member ${meter['Crew Members'][i]}`);
                if (Array.isArray(meter['Crew Members'][i])) {
                    // If our crew member is an array, its probably an array of [Name, Hours] and
                    // we only want the name.
                    flogger.debugall('Crew member is an array');
                    lastCrew.push(meter['Crew Members'][i][0]);
                } else if (meter['Crew Members'][i].Name) {
                    // If our crew member is an object with a Name and Hours, grab just the name
                    // and set the hours to 0 for our default value
                    flogger.debugall('Crew member is an object with a Name prop');
                    lastCrew.push({
                        Name: meter['Crew Members'][i].Name,
                        Hours: 0,
                    });
                } else {
                    flogger.debugall('Crew member should be just strings');
                    lastCrew.push(meter['Crew Members'][i]);
                }
            }
            flogger.debug(`Value used for default value: ${JSON.stringify(lastCrew)}`);
            lastUsedSettings.lastCrewSelected = lastCrew;
        },
        defaultValue: function crewMemberDefault(lastUsedSettings) {
            if (lastUsedSettings && lastUsedSettings.lastCrewSelected) {
                return lastUsedSettings.lastCrewSelected;
            }
            return [];
        },
    // }, {
    //     key: 'Parts Needed',
    //     modifiable: true,
    //     type: PROP_TYPES.SELECT_MULTI,
    //     choices: [
    //         '7" Resetter',
    //         '9" Resetter',
    //         '12" Resetter',
    //         'Retro Resetter',
    //         '3/4" Meter Adapter',
    //         'Tail Pieces',
    //     ],
    //     optional: true,
    // }, {
    //     key: 'Parts Used',
    //     modifiable: true,
    //     type: PROP_TYPES.SELECT_MULTI,
    //     choices: [
    //         '7" Resetter',
    //         '9" Resetter',
    //         '12" Resetter',
    //         'Retro Resetter',
    //         '3/4" Meter Adapter',
    //         'Tail Pieces',
    //     ],
    //     optional: true,
    // }, {
    //     key: 'Need to Schedule Water Outage',
    //     type: PROP_TYPES.BOOL,
    //     defaultValue: false,
    //     modifiable: true,
    }, {
        key: 'Install Type',
        modifiable: true,
        type: PROP_TYPES.SELECT,
        choices: [
            'Meter',
            'Retro Fit AMI Endpoint',
            'Retro Fit AMI Register and Endpoint',
        ],
        defaultValue: 'Meter',
    // }, {
    //     key: 'Install Hours',
    //     modifiable: true,
    //     type: PROP_TYPES.TIMER_TEXT,
    //     condition: function showInstallHours(meter) {
    //         // Only show this field if they've selected Hourly Rate for the Install Type
    //         return meter['Install Type'] === 'Hourly Rate';
    //     },
    //     completed: function installHoursCompleted(meter) {
    //         if (meter['Install Type'] === 'Hourly Rate') {
    //             if (meter['Install Hours'] > 0) {
    //                 return true;
    //             }
    //             return false;
    //         }
    //         return true;
    //     },
    //     validationFunc: function installHoursValid(value, meter) {
    //         if (meter['Install Type'] === 'Hourly Rate') {
    //             if (value > 0) {
    //                 return true;
    //             }
    //             return 'If Install Type is Hourly Rate, a value must be entered in '
    //                 + Install Hours.';
    //         }
    //         return true;
    //     },
    }, {
        key: 'Outgoing Meter Reading',
        modifiable: true,
        type: PROP_TYPES.NUMBER,
        htmlType: 'number',
        optional: true,
        // validationFunc: function outgoingMeterReadingValid(value, meter) {
        //     if (!value) {
        //         return 'A value must be entered.';
        //     }
        //     if (value < meter['Previous Reading']) {
        //         return 'The meter reading is less than the previous reading.';
        //     }
        //     if (value > meter['Previous Reading'] + 1000) {
        //         return 'The meter reading shows a consumption of more than 1000 above the ' +
        //             'previous reading. Is it correct?';
        //     }
        //     // The current import file doesn't have a high consumption value, so we don't have a
        //     // way to check if the value is too high.
        //     // if (value > this.meter['Last Meter Reading'] + this.meter['High Consumption']) {
        //     //     return 'This meter consumed more than it has ever previously consumed. Are you
        //     // sure you read it correctly?';
        //     // }
        //     return true;
        // },
    }, {
        key: 'Meter Size',
        modifiable: true,
        type: PROP_TYPES.SELECT,
        choices: [
            { text: '5/8"', value: '0.58' },
            { text: '3/4"', value: '0.75' },
            { text: '1"', value: '1' },
            { text: '1.25"', value: '1.25' },
            { text: '1.5"', value: '1.5' },
            { text: '2"', value: '2' },
            { text: '3"', value: '3' },
            { text: '4"', value: '4' },
            { text: '5"', value: '5' },
            { text: '6"', value: '6' },
            { text: '7"', value: '7' },
            { text: '8"', value: '8' },
        ],
        default: '0.58',
    }, {
        key: 'New Meter Serial',
        modifiable: true,
        type: PROP_TYPES.BARCODE,
        validationFunc: function newMeterSerialValid(value) {
            if (!METER_ID_RE.test(value)) {
                return 'The new meter serial number is expected to be of the format 2200XXXXX';
                // return 'The new meter serial number is expected to be 9 numbers';
            }
            return true;
        },

    // }, {
    //     key: 'New Meter Reading',
    //     modifiable: true,
    //     type: PROP_TYPES.NUMBER,
    //     defaultValue: 0,
    //     validationFunc: function newMeterReadingValid(value) {
    //         // if (this.meter['Install Type'] !== 'Replace Meter') {
    //         //     return true;
    //         // }
    //         if (value === undefined || value === '') {
    //             return 'A value must be entered.';
    //         }
    //         if (value > 10) {
    //             return `Most readings on new meters are less than 10. Are you sure the value of
    // ${value} is correct?`;
    //         }
    //         return true;
    //     },
    //     htmlType: 'number',
    }, {
        key: 'Transmitter ID',
        modifiable: true,
        type: PROP_TYPES.BARCODE,
        validationFunc: function transmitterIdValid(value) {
            if (!TRANSMITTER_ID_RE.test(value)) {
                return 'The transmitter ID is expected to be of the format 130XXXXXX';
                // return 'The transmitter ID is expected to be 9 numbers';
            }
            return true;
        },
    }, {
        key: 'New Lid Installed',
        type: PROP_TYPES.BOOL,
        defaultValue: false,
        modifiable: true,
    }, {
        key: 'New Holes Cut in Lid',
        type: PROP_TYPES.BOOL,
        defaultValue: false,
        modifiable: true,
    }, {
        key: 'Plasma Cut',
        type: PROP_TYPES.BOOL,
        defaultValue: false,
        modifiable: true,
    }, {
        key: 'Materials Used',
        modifiable: true,
        type: PROP_TYPES.SELECT_MULTI_EDITABLE,
        choices: [
            'Angle Valve',
            'Other',
        ],
        optional: true,
    }, {
        key: 'Install Date',
        modifiable: true,
        type: PROP_TYPES.DATE,
        defaultValue: function dateDefault() {
            // The date component presents a default value. But, we need this function so the
            // save function can grab a default value for the save.
            const now = new Date();
            return `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
        },
    }, {
        key: 'Uninstallable',
        type: PROP_TYPES.BOOL,
        defaultValue: false,
        modifiable: true,
    }, {
        key: 'Town Attention Needed',
        type: PROP_TYPES.BOOL,
        defaultValue: false,
        modifiable: true,
    }, {
        key: 'Notes',
        modifiable: true,
        type: PROP_TYPES.TEXTAREA,
        optional: true,
    },
    {
        name: 'Last Updated',
        key: 'Version',
        type: PROP_TYPES.ISO_TIMESTAMP,
    },
];

const GPS_LATITUDE_KEY = 'Service Point Latitude';
const GPS_LONGITUDE_KEY = 'Service Point Longitude';

const PHOTOS = [
    {
        name: 'Area Before',
        shortName: 'pre-exchange',
        key: 'Photo URL Pre-Exchange',
    }, {
        name: 'Final Reading',
        shortName: 'final-read',
        key: 'Photo URL Final Read',
    }, {
        name: 'New Meter Installed',
        shortName: 'new-meter',
        key: 'Photo URL New Meter',
    }, {
        name: 'Area After',
        shortName: 'post-exchange',
        key: 'Photo URL Post Exchange',
    },
];

// Everything else is pre-computed arrays that can be overriden with custom arrays if needed

const METER_PROPS_BY_KEY = {};
const METER_PROPS_BY_NAME = {};
for (let i = 0; i < METER_PROPS.length; i++) {
    // Apply our default values
    if (METER_PROPS[i].name === undefined) {
        // If we didn't specify a name, the name is the same as the key
        METER_PROPS[i].name = METER_PROPS[i].key;
    }
    if (METER_PROPS[i].type === undefined) {
        // If we didn't specify a type, set as string. This is needed for sorting.
        METER_PROPS[i].type = PROP_TYPES.STRING;
    }
    // Text and value are used by the Vuetify data table header objects
    METER_PROPS[i].text = METER_PROPS[i].name;
    METER_PROPS[i].value = METER_PROPS[i].key;
    if (METER_PROPS[i].modifiable === undefined) {
        METER_PROPS[i].modifiable = false;
    }
    METER_PROPS_BY_KEY[METER_PROPS[i].key] = METER_PROPS[i];
    METER_PROPS_BY_NAME[METER_PROPS[i].name] = METER_PROPS[i];
}

const METER_DETAILS_PROPS = METER_PROPS.filter((prop) => !prop.modifiable);

const METER_EDIT_PROPS = METER_PROPS.filter((prop) => prop.modifiable);

const INITIAL_SORT_PROPS = [
    METER_PROPS_BY_KEY['Account ID'],
];

const METER_LIST_COLS = [
    METER_PROPS_BY_KEY['Account ID'],
    METER_PROPS_BY_KEY['Service Address'],
    METER_PROPS_BY_KEY['Outgoing Meter Serial'],
];
const PHOTOS_BY_TYPE = {};
for (let i = 0; i < PHOTOS.length; i++) {
    PHOTOS_BY_TYPE[PHOTOS[i].shortName] = PHOTOS[i];
}

// To use this file in a CommonJS environment replace export with module.exports =.
export {
    ROUTE_KEY, PROP_TYPES,
    FEATURE_TOGGLES, METER_PROPS, METER_PROPS_BY_KEY,
    METER_PROPS_BY_NAME, METER_DETAILS_PROPS, NUM_DETAILS_SHOW, METER_EDIT_PROPS,
    INITIAL_SORT_PROPS, METER_LIST_COLS, PHOTOS, PHOTOS_BY_TYPE, GPS_LATITUDE_KEY,
    GPS_LONGITUDE_KEY,
};
